import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { mockData } from '../mock';

const Footer = () => {
  const { contactInfo } = mockData;

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="space-y-4">
            <img
              src="https://customer-assets.emergentagent.com/job_copal-construction/artifacts/0a1ulayb_Copal%20logo.png"
              alt="Copal Enterprises"
              className="h-10 w-auto brightness-0 invert"
            />
            <p className="text-sm leading-relaxed">
              Construyendo sueños con calidad, profesionalismo y compromiso desde hace más de 15 años.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-[#38B6FF] transition-colors duration-200">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-sm hover:text-[#38B6FF] transition-colors duration-200">
                  Servicios
                </Link>
              </li>
              <li>
                <Link to="/proyectos" className="text-sm hover:text-[#38B6FF] transition-colors duration-200">
                  Proyectos
                </Link>
              </li>
              <li>
                <Link to="/nosotros" className="text-sm hover:text-[#38B6FF] transition-colors duration-200">
                  Nosotros
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-sm hover:text-[#38B6FF] transition-colors duration-200">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Servicios</h3>
            <ul className="space-y-2 text-sm">
              <li>Construcción Residencial</li>
              <li>Construcción Comercial</li>
              <li>Remodelación de Interiores</li>
              <li>Remodelación de Cocinas</li>
              <li>Remodelación de Baños</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-[#38B6FF] flex-shrink-0 mt-0.5" />
                <span className="text-sm">{contactInfo.phone}</span>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-[#38B6FF] flex-shrink-0 mt-0.5" />
                <span className="text-sm">{contactInfo.email}</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#38B6FF] flex-shrink-0 mt-0.5" />
                <span className="text-sm">{contactInfo.address}</span>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex space-x-4 mt-6">
              <a
                href={contactInfo.socialMedia.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#0057CB] transition-colors duration-300"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href={contactInfo.socialMedia.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#38B6FF] transition-colors duration-300"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-10 pt-8 text-center">
          <p className="text-sm">
            © {new Date().getFullYear()} Copal Enterprises. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
